import { render, staticRenderFns } from "./ProjectTaskDetails.vue?vue&type=template&id=074b7efc&scoped=true&"
import script from "./ProjectTaskDetails.vue?vue&type=script&lang=js&"
export * from "./ProjectTaskDetails.vue?vue&type=script&lang=js&"
import style0 from "./ProjectTaskDetails.vue?vue&type=style&index=0&id=074b7efc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074b7efc",
  null
  
)

export default component.exports